import React from 'react';

// Types
import { GoalItem } from 'Shared/constants/types';

// Components
import GoalCardDropdown from '../../GoalCardDropdown/GoalCardDropdown';

type Props = {
  goal: GoalItem;
  handleMarkComplete: Function;
  handleMarkIncomplete: Function;
  handleChangeStatus: Function;
  redirectToGoalDetailPage: Function;
};

const GoalActions = ({
  goal,
  handleMarkComplete,
  handleMarkIncomplete,
  handleChangeStatus,
  redirectToGoalDetailPage,
}: Props) => {
  return (
    <GoalCardDropdown
      slug={goal.slug}
      goal={goal}
      handleMarkComplete={handleMarkComplete}
      handleMarkIncomplete={handleMarkIncomplete}
      handleChangeStatus={handleChangeStatus}
      redirectToGoalDetailPage={redirectToGoalDetailPage}
    />
  );
};

export default GoalActions;
